export default "__VITE_ASSET__B2g5b9fL__"